import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { PREVIEW_SIZE } from '../../constants';
import type { PolicyData } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCard } from '../PolicySearch/SearchPolicyCard';
import { SearchPolicyCardSkeletonList } from '../PolicySearch/SearchPolicyCardSkeleton';
import { SectionHeader } from './SectionHeader';
export function PolicyPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  const t1 = isLoading ? undefined : totalCount;
  let t2;
  if ($[0] !== keyword) {
    t2 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "policy"
      }
    });
    $[0] = keyword;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SectionHeader title={"\uC815\uCC45"} totalCount={t1} moreHref={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoading || $[6] !== items) {
    t4 = isLoading ? <SearchPolicyCardSkeletonList count={PREVIEW_SIZE} /> : <div className="flex flex-col gap-12 mobile-tablet:gap-0">{items.map((policy, index) => <Fragment key={policy.id}><SearchCategoryAdSlot placement="search-all-policy" position={index + 1} listLength={items.length} /><SearchPolicyCard policy={policy} /></Fragment>)}</div>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <section className="flex w-full flex-col">{t3}{t4}</section>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}